import config from "../config";

function safeOrigin(urlValue) {
  try {
    return new URL(urlValue).origin;
  } catch {
    return "";
  }
}

const apiOrigin = safeOrigin(config.API_BASE_URL);

export function normalizeMediaUrl(input) {
  if (!input || typeof input !== "string") return "";

  const trimmed = input.trim();
  if (!trimmed) return "";

  // Already relative to the current frontend host.
  if (trimmed.startsWith("/uploads/")) {
    return `${apiOrigin}${trimmed}`;
  }

  // Handle legacy values like "uploads/patients/..."
  if (trimmed.startsWith("uploads/")) {
    return `${apiOrigin}/${trimmed}`;
  }

  try {
    const parsed = new URL(trimmed);
    const isLocalHost =
      parsed.hostname === "localhost" ||
      parsed.hostname === "127.0.0.1" ||
      parsed.hostname === "::1";

    // Normalize old local ports (e.g. 5003) to active API host for uploaded media.
    if (isLocalHost && parsed.pathname.startsWith("/uploads/")) {
      return `${apiOrigin}${parsed.pathname}`;
    }

    return trimmed;
  } catch {
    return trimmed;
  }
}
